import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return r(), o("svg", n, e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.76 2.154a10.016 10.016 0 0 0-11.014 6.06A10 10 0 0 0 5.593 19.68a1 1 0 1 1-1.282 1.536A12 12 0 0 1 .895 7.456 12.016 12.016 0 0 1 14.11.186a1 1 0 0 1-.35 1.968M18.28 2.912a1 1 0 0 1 1.409-.127 12 12 0 0 1 3.424 13.739 12.006 12.006 0 0 1-13.439 7.25 1 1 0 1 1 .386-1.962A10.015 10.015 0 0 0 21.26 15.77 10 10 0 0 0 18.407 4.32a1 1 0 0 1-.127-1.408",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      d: "M9.76 5.699h-.017c-.611.01-1.104.563-1.104 1.174 0 .618.501 1.175 1.118 1.175h1.815v9.096l.006.279c.025.666.496 1.197 1.168 1.197s1.147-.531 1.175-1.197V6.873c0-.682-.494-1.174-1.175-1.174z"
    }, null, -1)
  ]));
}
const a = { render: t };
export {
  a as default,
  t as render
};
//# sourceMappingURL=ic_1-BnEu0quj.js.map
